import { inject, InjectionToken, signal } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation } from '@softline/core';
import { SOFTLINE_API_TIMESTAMP } from '../../stempelerfassung.api';
import { TimestampData } from '../../data/timestamp.model';

export class StampCaptureRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  retrieve(from, to, employeeId): Promise<TimestampData> {
    return this.#dataAccess.get(
      this.location(SOFTLINE_API_TIMESTAMP, {
        from,
        to,
        employeeid: employeeId,
      })
    );
  }

  private location(path: string, queryParams): ApiResourceLocation {
    return {
      path,
      queryParams,
    };
  }
}

export class StampCaptureObjectService {
  constructor(private _repository: StampCaptureRepository) {}

  public isStamped = signal<boolean>(false);

  async retrieve(from, to, employeeId): Promise<TimestampData> {
    const response = await this._repository.retrieve(from, to, employeeId);
    if (response.result && response.result.length > 0) {
      const isStamped = response.result[response.result.length - 1].flag === 'arrival';
      this.isStamped.set(isStamped);
    }
    return response;
  }
}

export const StampCaptureService = new InjectionToken<StampCaptureObjectService>(
  'StampCaptureService'
);

export function provideStampCaptureService() {
  return {
    provide: StampCaptureService,
    useFactory: () => {
      return new StampCaptureObjectService(new StampCaptureRepository());
    },
  };
}
